import * as Translations from './TranslationFields';
import { ILinkTranslation } from './Translations';

export type ITranslationSchema = Partial<Record<keyof ITranslations, string | ILinkTranslation>>;

export type ITranslations =
  Translations.AccountTranslations &
  Translations.CartTranslations &
  Translations.CommunicationsTranslations &
  Translations.CommonTranslations &
  Translations.CheckoutTranslations &
  Translations.GeneralTranslations &
  Translations.OffersTranslations &
  Translations.ProductTranslations &
  Translations.StoreLocatorTranslations &
  Translations.UserTranslations &
  Translations.CartErrorTranslations &
  Translations.AccountErrorTranslations &
  Translations.ErrorTranslations & {
    [key: string]: string;
  };

// define new key names for cases when duplicate key names are used within different translation sets
// and for reserved words
export const enforcedTranslationMapping = new Map<string, string>([
  ['elc_product.quantity', 'productQuantities'],
  ['elc_user.city', 'cityLabel'],
  ['elc_user.state', 'stateLabel'],
  ['elc_checkout.gift_wrap', 'giftWrapText'],
  ['elc_checkout.company_name', 'checkoutCompanyName'],
  ['elc_checkout.shipping', 'checkoutShipping'],
  ['elc_errors.city_required', 'cityRequiredError'],
  ['elc_errors.state_required', 'stateRequiredError'],
  ['elc_errors.address_required', 'addressRequiredError'],
  ['elc_user.municipality', 'municipalityLabel'],
  ['elc_user.colony', 'colonyLabel'],
  ['elc_stores.store_closed', 'storeClosedText'],
  ['elc_offers.apply', 'offerApply'],
  ['elc_product.apply', 'productApply'],
  ['elc_checkout.offer_code', 'checkoutOfferCode'],
  ['elc_offers.offer_code', 'offersOfferCode'],
  ['elc_product.learn_more', 'productLearnMore'],
  ['elc_general.delete', 'deleteLabel'],
  ['elc_general.default', 'defaultLabel'],
  ['elc_product.loading', 'productLoading'],
]);
